import { decryptRole } from './roles';
import { isPublicCompany } from './company';

export function currentUser() {
  return JSON.parse(localStorage.getItem('currentUser'));
}

export function currentUserRole() {
  const user = currentUser();
  if (!user || !user.role) {
    return null;
  }
  const decryptedRole = decryptRole(user.role);
  if (decryptedRole !== 'admin' && isPublicCompany()) {
    return 'guest';
  }
  return decryptedRole;
}

export function isAdminUser() {
  return currentUserRole() === 'admin';
}

export function isGuestUser() {
  return currentUserRole() === 'guest';
}
